import Chart from "react-apexcharts";
// import Navbar from "../layout/Navbar";
// import CardBox from "../components/CardBox";
// import GenderReport from "../components/GenderReport";
// import AgeCategoryReport from "../components/AgeCategoryReport";
import { useCallback, useEffect, useState } from "react";
import axios from "../api/axios";
import Select from "react-select";
// import useAuth from "../hooks/useAuth";
// import Helper from "../utils/utils";
// import SideBarWrapper from "../components/SideBarWrapper";
import DPATAssessmentSheet from "../components/DPATAssessmentSheet";
import { Button, Spin } from "antd";
import { filterTrackedEntitiesByYear, formatDataGeneral } from "../utils/utils";
import { dpatRelaxedTrackerEndDate, dpatRelaxedTrackerStartDate, filterRecordsByDpatYearAttribute, isDpatScoreRelaxationExempt, setDpatScoreRelaxationExempt, syncDpatScoreRelaxation } from "../utils/dpatScoreRelaxation";
import useAuth from "../hooks/useAuth";

const years = [
    { label: 2015, value: 2015 },
    { label: 2016, value: 2016 },
    { label: 2017, value: 2017 },
    { label: 2018, value: 2018 },
    { label: 2019, value: 2019 },
    { label: 2020, value: 2020 },
    { label: 2021, value: 2021 },
    { label: 2022, value: 2022 },
    { label: 2023, value: 2023 },
    { label: 2024, value: 2024 },
    { label: 2025, value: 2025 },
    { label: 2026, value: 2026 },
];

const TRACKER_ENTITIES_PAGE_SIZE = 5000;
const TRACKER_EVENTS_PAGE_SIZE = 10000;

function resolveDistrictIdFromLocationOption(val) {
    if (!val) return null;
    if (typeof val.value === "object" && val.value?.id != null) return val.value.id;
    if (typeof val.value === "string" || typeof val.value === "number") return val.value;
    return null;
}

function resolveYearValueForPeriod(timePeriod) {
    if (timePeriod == null) return null;
    if (typeof timePeriod === "number") return timePeriod;
    if (typeof timePeriod === "object" && timePeriod.value != null) return timePeriod.value;
    if (typeof timePeriod === "string") {
        const n = Number(timePeriod);
        return Number.isFinite(n) ? n : timePeriod;
    }
    return null;
}

function resolveRegionFromLocationOption(val) {
    if (!val?.value) return null;
    if (typeof val.value === "object") return val.value.region ?? null;
    return null;
}

function DPATAssessment({
    selectedLocation,
    timePeriod,
    bulkSnapshotRequest,
    onBulkSnapshotReady,
    onBulkSnapshotError,
    onBulkSnapshotCollectorReady,
    bulkSnapshotMode = false,
}) {
    const { user } = useAuth();

    const [districts, setDistricts] = useState(null);
    const [gaMeeting, setGaMeeting] = useState(null);
    const [meetingDecision, setMeetingDecision] = useState([]);
    const [districtDepartments, setDistrictDepartments] = useState([]);
    const [districtMembers, setDistrictMembers] = useState([]);
    const [districtGeneral, setDistrictGeneral] = useState([]);
    const [audit, setAudit] = useState([]);
    const [schools, setSchools] = useState([]);
    const [foodVendors, setFoodVendors] = useState([]);
    const [pAndP, setPAndP] = useState(null);
    const [transportors, setTransportors] = useState([]);
    const [inspectorateUnit, setInspectorateUnit] = useState([]);
    const [igf, setIGF] = useState([]);
    const [publications, setPublications] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [serviceProviders, setServiceProviders] = useState([]);
    const [inspectorates, setInspectorates] = useState([]);
    const [permiRequest, setPermiRequest] = useState([]);
    const [streetNaming, setStreetNaming] = useState([]);
    const [annualActionPlan, setAnnualActionPlan] = useState([]);
    const [subStructures, setSubStructures] = useState([]);
    const [subStructuresActivity, setSubStructuresActivity] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [sheetBootstrapLoading, setSheetBootstrapLoading] = useState(false);
    const [dataRefreshKey, setDataRefreshKey] = useState(0);

    useEffect(() => {
        // Check if districts exist in localStorage
        const storedDistricts = localStorage.getItem("districts");

        if (storedDistricts) {
            const data = JSON.parse(storedDistricts);

            // Collect all district IDs into a Set
            const districtIds = new Set(user?.user?.districts?.map(d => d.id));

            // Filter options by matching district IDs
            const filteredOptions =
                user?.user?.userRoles?.find(role => role.name === "Superuser") ?
                    data : data.filter(opt => districtIds.has(opt.value.id));
            setDistricts(filteredOptions);

        }
    }, []);

    useEffect(() => {
        if (gaMeeting) setSheetBootstrapLoading(false);
    }, [gaMeeting]);

    function pullTrackerInstance(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=Ch38jUWJpUR&filter=Ub0V9Z06aBc:GE:${startDate}:LE:${endDate}&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                axios
                    .get(`/tracker/events?program=Ch38jUWJpUR&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                    .then(resp => {
                        setGaMeeting({ meetings: result.data.instances, reports: resp.data.instances });
                    })
                    .catch(err => console.log(err))
            })
            .catch(err => console.log(err))
    }

    function pullDecisionTrackerInstance(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=n8WIhwDrAO7&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=n8WIhwDrAO7&orgUnit=${districtId}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            // console.log("Sow decisions", result.data.instances)
                            setMeetingDecision({ decisions: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }
            })
            .catch(err => console.log("decisions error ", err))
    }

    function pullSubStructureEstablishment(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=vkJZ5R2mSJ3&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=vkJZ5R2mSJ3&orgUnit=${districtId}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setSubStructures({ sub: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getSubStructuresActivity(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=p1vYbSWkgyD&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {
                    console.log("activities: ", result.data.instances);
                    axios
                        .get(`/tracker/events?program=p1vYbSWkgyD&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setSubStructuresActivity({ activities: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getDistrictAssemblyDepartment(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=mAEretIhuqM&filter=Ub0V9Z06aBc:GE:${startDate}:LE:${endDate}&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=mAEretIhuqM&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setDistrictDepartments({ dep: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getMembersByDistrict(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=AJDfCnHCQ2j&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {
                    // console.log("members: ",result.data.instances)

                    axios
                        .get(`/tracker/events?program=AJDfCnHCQ2j&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setDistrictMembers({ members: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getServiceProviderList(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=nGFVo65uUE4&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=nGFVo65uUE4&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setServiceProviders({ providers: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getInspectorateList(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=p1ccS2ROn0Q&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=p1ccS2ROn0Q&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setInspectorates({ inspectorates: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getPermitRequest(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=w2au8V5taU8&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=w2au8V5taU8&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setPermiRequest({ permits: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getStreetNaming(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=joUkaNeiZ0O&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=joUkaNeiZ0O&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setStreetNaming({ streets: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getAnnualActionPlan(startDate, endDate, districtId, year) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=ArLnAxhykoz&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=ArLnAxhykoz&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            const data = isDpatScoreRelaxationExempt()
                                ? filterRecordsByDpatYearAttribute(result.data.instances, year)
                                : (formatDataGeneral(result.data.instances, "Year", `${year}`) || []);
                            setAnnualActionPlan({ aap: data, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getDistrictGeneral(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=RwWtjFaorvN&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=RwWtjFaorvN&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setDistrictGeneral({ data: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getAudits(startDate, endDate, districtId, yearNum) {
        const selectedYear = yearNum || String(startDate || "").slice(0, 4);

        const auditFilter = isDpatScoreRelaxationExempt()
            ? ""
            : `&filter=Ik7fouv4KOA:EQ:${selectedYear}`;

        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=Z3qMezPtpEb${auditFilter}&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                const instances = result.data.instances || [];

                if (instances.length === 0) {
                    setAudit({ data: [], reports: [] });
                    return;
                }

                axios
                    .get(`/tracker/events?program=Z3qMezPtpEb&orgUnit=${districtId}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                    .then(resp => {
                        const trackedEntityIds = new Set(instances.map((item) => item.trackedEntity));
                        const reports = (resp.data.instances || []).filter(
                            (event) => trackedEntityIds.has(event.trackedEntity),
                        );
                        setAudit({ data: instances, reports });
                    })
                    .catch(err => console.log(err))
            })
            .catch(err => console.log(err))
    }

    function getSchoolRegistered(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=g27TeeehRQC&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=g27TeeehRQC&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setSchools({ data: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getFoodVendors(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=abiQOocP8YA&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=abiQOocP8YA&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setFoodVendors({ data: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getProjectAndProgramme(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=g3wMUKEMmH3&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=g3wMUKEMmH3&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            //  console.log("Djiba p&p: ", result.data.instances)
                            const data = filterTrackedEntitiesByYear(result.data.instances, startDate, endDate);

                            // console.log("Djiba p&p: ", data)

                            setPAndP({ data, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                } else if (onBulkSnapshotReady) {
                    setPAndP({ data: [], reports: [] });
                }


            })
            .catch(err => console.log(err))
    }

    function getTransportors(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=R5MX47LvztN&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}&fields=trackedEntity,createdAt,attributes[attribute,displayName,value]`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=R5MX47LvztN&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setTransportors({ data: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getInspectorateUnits(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=pYvmkB4s6Nq&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=pYvmkB4s6Nq&orgUnit=${districtId}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}&fields=event,trackedEntity,programStage,createdAt,scheduledAt,occurredAt,eventDate,dataValues[dataElement,displayName,value]`)
                        .then(resp => {
                            setInspectorateUnit({ data: result.data.instances, reports: resp.data.instances })
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getIGFDetails(startDate, endDate, districtId) {
        const igfYearFilter = isDpatScoreRelaxationExempt()
            ? ""
            : `&filter=pWkYqcKukAY:EQ:${selectedYear?.value}`;
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=dYNmYGtArrK${igfYearFilter}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}&fields=trackedEntity,attributes[attribute,displayName,value]`)
            .then(result => {
                const instances = result.data?.instances || [];
                const data = isDpatScoreRelaxationExempt()
                    ? filterRecordsByDpatYearAttribute(instances, selectedYear?.value)
                    : (formatDataGeneral(instances, "Year", `${selectedYear?.value}`)
                    || formatDataGeneral(instances, "Select Year", `${selectedYear?.value}`)
                    || instances.filter((record) => {
                        const yearValue = record?.attributes?.find(
                            (attr) => attr.attribute === "pWkYqcKukAY",
                        )?.value;
                        return String(yearValue) === String(selectedYear?.value);
                    }));
                setIGF({ data, reports: [] })
            })
            .catch(err => console.log(err))
    }

    function getDocumentHub(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=SERtHvYVHRT&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {
                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=SERtHvYVHRT&orgUnit=${districtId}&startDate=${startDate}&endDate=${endDate}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setDocuments({ data: result.data.instances, reports: resp.data.instances });
                        })
                        .catch(err => console.log(err))
                }


            })
            .catch(err => console.log(err))
    }

    function getPublications(startDate, endDate, districtId) {
        axios
            .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=X5kGqVpbGoN&pageSize=${TRACKER_ENTITIES_PAGE_SIZE}`)
            .then(result => {

                if (result.data.instances.length > 0) {

                    axios
                        .get(`/tracker/events?program=X5kGqVpbGoN&orgUnit=${districtId}&pageSize=${TRACKER_EVENTS_PAGE_SIZE}`)
                        .then(resp => {
                            setPublications({ data: result.data.instances, reports: resp.data.instances });
                        })
                        .catch(err => console.log(err))
                }
            })
            .catch(err => console.log("decisions error ", err))
    }

    const getData = useCallback(() => {
        const val = selectedLocation;
        const districtId = resolveDistrictIdFromLocationOption(val);
        const yearNum = resolveYearValueForPeriod(timePeriod);

        if (!districtId || yearNum == null) {
            return;
        }

        setSheetBootstrapLoading(true);
        setGaMeeting(null);
        setMeetingDecision([]);
        setSubStructures([]);
        setDistrictDepartments([]);
        setDistrictMembers([]);
        setSubStructuresActivity([]);
        setServiceProviders([]);
        setInspectorates([]);
        setPermiRequest([]);
        setStreetNaming([]);
        setAnnualActionPlan([]);
        setDistrictGeneral([]);
        setFoodVendors([]);
        setSchools([]);
        setAudit([]);
        setTransportors([]);
        setInspectorateUnit([]);
        setIGF([]);
        setDocuments([]);
        setPublications([]);
        setPAndP([]);

        setSelectedDistrict({ value: districtId, label: val.label });
        setSelectedRegion(resolveRegionFromLocationOption(val) ?? (typeof val.value === "object" ? val.value.region : null));
        setSelectedYear({ value: yearNum, label: yearNum });

        syncDpatScoreRelaxation(false, yearNum);
        const startDate = dpatRelaxedTrackerStartDate(yearNum);
        const endDate = dpatRelaxedTrackerEndDate(yearNum);

        pullTrackerInstance(startDate, endDate, districtId);

        pullDecisionTrackerInstance(startDate, endDate, districtId);

        pullSubStructureEstablishment(startDate, endDate, districtId);

        getDistrictAssemblyDepartment(startDate, endDate, districtId);
        getProjectAndProgramme(startDate, endDate, districtId);

        getMembersByDistrict(startDate, endDate, districtId);
        getSubStructuresActivity(startDate, endDate, districtId);
        getServiceProviderList(startDate, endDate, districtId);
        getInspectorateList(startDate, endDate, districtId);
        getPermitRequest(startDate, endDate, districtId);
        getStreetNaming(startDate, endDate, districtId);
        getAnnualActionPlan(startDate, endDate, districtId, yearNum);
        getDistrictGeneral(startDate, endDate, districtId);
        getFoodVendors(startDate, endDate, districtId);
        getSchoolRegistered(startDate, endDate, districtId);
        getAudits(startDate, endDate, districtId, yearNum);
        getTransportors(startDate, endDate, districtId);
        getInspectorateUnits(startDate, endDate, districtId);
        getIGFDetails(startDate, endDate, districtId);
        getDocumentHub(startDate, endDate, districtId);
        getPublications(startDate, endDate, districtId);
    }, [selectedLocation, timePeriod]);

    const handleAssessmentStarted = useCallback(() => {
        setDataRefreshKey((k) => k + 1);
        getData();
    }, [getData]);

    useEffect(() => {
        if (!selectedLocation) return;
        getData();
    }, [selectedLocation, timePeriod, getData]);

    useEffect(() => () => setDpatScoreRelaxationExempt(false), []);

    return (

        <>

            {/* Page wrapper start */}
            <div className="page-wrapper">

                <div className="page-content">

                    {/* Main container start */}
                    <div className="main-container">
                        {sheetBootstrapLoading && selectedLocation && (
                            <div style={{ display: "flex", justifyContent: "center", padding: "48px 16px" }}>
                                <Spin size="large" tip="Loading assessment data…" />
                            </div>
                        )}

                        {gaMeeting && selectedYear && selectedDistrict && pAndP && (
                            <DPATAssessmentSheet
                                key={`${selectedDistrict.value}-${selectedYear.value}-${dataRefreshKey}`}
                                onAssessmentStarted={handleAssessmentStarted}
                                bulkSnapshotRequest={bulkSnapshotRequest}
                                onBulkSnapshotReady={onBulkSnapshotReady}
                                onBulkSnapshotError={onBulkSnapshotError}
                                onBulkSnapshotCollectorReady={onBulkSnapshotCollectorReady}
                                bulkSnapshotMode={bulkSnapshotMode}
                                props={{
                                    meetings: gaMeeting,
                                    decisions: meetingDecision,
                                    subStructures: subStructures,
                                    departments: districtDepartments,
                                    year: selectedYear?.value,
                                    district: selectedDistrict,
                                    region: selectedRegion,
                                    members: districtMembers,
                                    subActivity: subStructuresActivity,
                                    serviceProviders: serviceProviders,
                                    inspectorates: inspectorates,
                                    permitRequest: permiRequest,
                                    streets: streetNaming,
                                    plans: annualActionPlan,
                                    districtGeneral: districtGeneral,
                                    foodVendors: foodVendors,
                                    schools: schools,
                                    audits: audit,
                                    transportors: transportors,
                                    inspectorateUnits: inspectorateUnit,
                                    ifg: igf,
                                    documents: documents,
                                    publications: publications,
                                    pAndP: pAndP
                                }}
                            />
                        )}


                    </div>
                    {/* Main container end */}
                </div>
                {/* Page content end */}

            </div>
            {/* Page wrapper end */}

        </>
    );
}
export default DPATAssessment;
